<template>
	<div>
		<app-overlay-loader v-if="!dataLoaded"/>
		<div v-else class="content-wrapper">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<app-breadcrumb
						:button="{label: $t('back'), url:urlGenerator(`crm/renewe/list`)}"
						:directory="[$t('contacts'), name]"
						:icon="'users'"
						:page-title="name"
					/>
				</div>
			</div>
			<div class="row">
				<div class="col-xl-4">
					
					<app-details-information-renewe
						class="mb-primary"
						:details-data="formData"
						:details-sync-url="`crm/renewes/${formData.id}`"
					@update-request="updateRequest"/>
					
					
				</div>
				<div class="col-xl-8">
					<div class="row">
				
				
					
					<div class="col-xl-12">
				
					<app-tab v-if="appTapShow" :tabs="todoActivityTab" class="mb-primary" type="horizontal"/>
				
          <app-common-activity-show-fund
            :Data="formData"
            :edit-url="selectedUrl"
            :file-note-url="`crm/renewe`"
            component-type="renewe"
            v-if="isComponent"
            @open-note-modal="editNote"
          />
				</div>
					</div>
					
				</div>
				
				
			</div>

		

			

			<app-common-note-modal v-if="isNoteModal" :note="noteRowData" @close-modal="closeNoteModal"/>

		</div>
	</div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, onlyTime, onlyTimeFromTime, textTruncate, urlGenerator} from "@app/Helpers/helpers";
	
	

export default {
	props: ["selectedUrl"],
	name: "ReneweDetails",
	mixins: [FormMixin],


	data() {
		return {
			urlGenerator,
			dataLoaded: false,
			preLoader: false,
			isDealModalActive: false,
			isNoteModal: false,
			reneweActivitiesModal: false,
			formData: {},
			appTapShow: false,
			isComponent: true,
			name: "",
			editedUrl: "",
			activitiesList: [],
			isfileNoteFilter: true,

			// Tab Start
			todoActivityTab: [
				{
					name: this.$t("note"),
					icon: "file-text",
					component: "common-note-tab",
					props: "",
					permission: "",
				},
				{
					name: this.$t("file"),
					icon: "paperclip",
					component: "common-file-tab",
					props: "",
					permission: "",
				},

				
				
			],


			rowData: null,
			dealNoteModal: false,
			noteRowData: null,
			value: "",
			formatDateToLocal,
			onlyTimeFromTime,
			onlyTime,
			textTruncate,
		};
	},
	computed: {
	
		
	},
	methods: {
		afterSuccessFromGetEditData(response) {
			this.formData = response.data;
			this.name = 'Реставрация: '+this.formData.fund.name;
			this.todoActivityTab.forEach((el) => {
				el["props"] = {
					id: this.formData.id,
					renewe: "renewe",
					contextable_type: "App\\Models\\CRM\\Renewe\\Renewe",
					
					fileSyncUrl: `crm/renewe/file/sync/${this.formData.id}`,
					noteSyncUrl: `crm/renewe/note/sync/${this.formData.id}`,
				};
			});

			this.appTapShow = true;
      this.dataLoaded = true;
		},
		
		
		setUser() {
      this.user = {
        full_name: window.user.full_name,
        img: window.user.profile_picture
          ? urlGenerator(window.user.profile_picture.path)
          : urlGenerator("/images/profile.png"),
        status: this.$t("online"),
        role: this.$t(window.user.roles[0].name),
      };
    },
		
		
		

		updateRequest() {
			this.isComponent = false;
			this.axiosGet(this.selectedUrl).then((response) => {
				this.formData = response.data;
				this.name = 'Реставрация: '+this.formData.fund.name;
				this.isComponent = true;
			}).catch((error) => console.log(error));
		},

		
	
		
		

		editNote(activity) {
			this.isNoteModal = true;
			this.noteRowData = activity;
			setTimeout(() => {
				$("#note-modal").modal("show");
			});
		},
		closeNoteModal() {
			this.isNoteModal = false;
			$("#note-modal").modal("hide");
		},
	},

	mounted() {
		
		this.setUser();
		
	
		
		
	},
};
</script>
